export const JAPAN_REGIONS = [
  {
    id: 'kanto',
    name: 'Kanto',
    prefectures: ['Tokyo', 'Kanagawa', 'Chiba', 'Saitama', 'Ibaraki', 'Tochigi', 'Gunma'],
  },
  {
    id: 'kansai',
    name: 'Kansai',
    prefectures: ['Osaka', 'Kyoto', 'Hyogo', 'Nara', 'Wakayama', 'Shiga'],
  },
  {
    id: 'chubu',
    name: 'Chubu',
    prefectures: ['Aichi', 'Shizuoka', 'Gifu', 'Mie', 'Niigata', 'Toyama', 'Ishikawa', 'Fukui', 'Yamanashi', 'Nagano'],
  },
  {
    id: 'tohoku',
    name: 'Tohoku',
    prefectures: ['Miyagi', 'Aomori', 'Iwate', 'Akita', 'Yamagata', 'Fukushima'],
  },
  {
    id: 'hokkaido',
    name: 'Hokkaido',
    prefectures: ['Hokkaido'],
  },
  {
    id: 'chugoku',
    name: 'Chugoku',
    prefectures: ['Hiroshima', 'Okayama', 'Tottori', 'Shimane', 'Yamaguchi'],
  },
  {
    id: 'shikoku',
    name: 'Shikoku',
    prefectures: ['Tokushima', 'Kagawa', 'Ehime', 'Kochi'],
  },
  {
    id: 'kyushu',
    name: 'Kyushu & Okinawa',
    prefectures: ['Fukuoka', 'Saga', 'Nagasaki', 'Kumamoto', 'Oita', 'Miyazaki', 'Kagoshima', 'Okinawa'],
  },
];

/** Common cities/areas per prefecture (users can type others) */
export const POPULAR_CITIES = {
  Tokyo:     ['Shinjuku', 'Shibuya', 'Ikebukuro', 'Ueno', 'Akihabara', 'Yokohama'],
  Osaka:     ['Namba', 'Umeda', 'Tennoji', 'Shinsaibashi'],
  Kyoto:     ['Gion', 'Kawaramachi', 'Arashiyama'],
  Aichi:     ['Nagoya', 'Toyota', 'Okazaki'],
  Fukuoka:   ['Hakata', 'Tenjin'],
  Hokkaido:  ['Sapporo', 'Otaru', 'Asahikawa'],
  Kanagawa:  ['Yokohama', 'Kawasaki', 'Fujisawa'],
  Hyogo:     ['Kobe', 'Himeji'],
};

export const DEFAULT_PREFECTURE = 'Tokyo';

export function findRegionForPrefecture(pref) {
  return JAPAN_REGIONS.find(r => r.prefectures.includes(pref)) || JAPAN_REGIONS[0];
}
